<template>
  <modal
    :active="active"
    size="auto"
    :close-on-click-outside="true"
    primary-button-label="Submit"
    tertiary-button-label="Cancel"
    @onClose="$emit('onModalClose')"
    @onConfirm="submitReject">
    <template #header>
      <p>Select a reason for rejection</p>
    </template>
    <template #content>
      <div class="theme--light">
        <div
          v-for="reason in rejectReasons"
          :key="reason"
          class="reason-row"
          @click="selectReason(reason)">
          <Radio
            :id="reason.toLowerCase().replace(/\s+/g, '-')"
            :label="reason"
            :checked="selectedReason === reason" />
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
export default {
  name: "RejectCommentsModal",
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    rejectReasons: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedReason: "", // Initial state
    };
  },
  methods: {
    selectReason(reason) {
      this.selectedReason = reason;
      //console.log("Selected reason:", this.selectedReason);
    },
    submitReject(selectedReason) {
      //console.log("Submitting reason:", this.selectedReason);

      this.$emit("onReject", this.selectedReason);
      this.$emit("onModalClose");
    },
  },
};
</script>

<style scoped>
.reason-row {
  margin-bottom: 10px;
  cursor: pointer;
}
</style>
